module.exports = __webpack_public_path__ + "img/Share.4de8f32f.svg";